/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Box,
  CircularProgress,
  Grid,
} from '@material-ui/core';
import { DateTime } from 'luxon';
import { formatAmount } from '@omega-energia/utilities';

function ModalPurchaseOrderData({ isOpen, onClose, poData, isLoading }) {
  const formatDate = dateString => {
    if (!dateString) {
      return '--';
    }
    try {
      return DateTime.fromISO(dateString).toFormat('dd/MM/yyyy HH:mm');
    } catch {
      return dateString;
    }
  };

  return (
    <Dialog open={isOpen} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography>Dados da Ordem de Compra (PO) na Oracle</Typography>
      </DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" style={{ minHeight: '200px' }}>
            <CircularProgress />
          </Box>
        ) : poData ? (
          <Box style={{ marginTop: '16px' }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Número da PO
                </Typography>
                <Typography variant="body1">{poData.orderNumber || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Status
                </Typography>
                <Typography variant="body1">{poData.status || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Valor Total
                </Typography>
                <Typography variant="body1">{poData.total ? formatAmount(poData.total) : '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Moeda
                </Typography>
                <Typography variant="body1">{poData.currencyCode || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Fornecedor
                </Typography>
                <Typography variant="body1">{poData.supplier || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Site do Fornecedor
                </Typography>
                <Typography variant="body1">{poData.supplierSite || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Comprador
                </Typography>
                <Typography variant="body1">{poData.buyer || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  PO Header ID
                </Typography>
                <Typography variant="body1">{poData.poHeaderId || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Procurement BU
                </Typography>
                <Typography variant="body1">{poData.procurementBU || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Requisitioning BU
                </Typography>
                <Typography variant="body1">{poData.requisitioningBU || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Bill To BU
                </Typography>
                <Typography variant="body1">{poData.billToBU || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Data de Criação
                </Typography>
                <Typography variant="body1">{formatDate(poData.creationDate)}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Criado Por
                </Typography>
                <Typography variant="body1">{poData.createdBy || '--'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Última Atualização
                </Typography>
                <Typography variant="body1">{formatDate(poData.lastUpdateDate)}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  Atualizado Por
                </Typography>
                <Typography variant="body1">{poData.lastUpdatedBy || '--'}</Typography>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" style={{ minHeight: '200px' }}>
            <Typography variant="body2">Nenhum dado encontrado</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalPurchaseOrderData.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  poData: PropTypes.shape({
    poHeaderId: PropTypes.number,
    orderNumber: PropTypes.string,
    status: PropTypes.string,
    procurementBU: PropTypes.string,
    requisitioningBU: PropTypes.string,
    billToBU: PropTypes.string,
    buyer: PropTypes.string,
    supplier: PropTypes.string,
    supplierSite: PropTypes.string,
    currencyCode: PropTypes.string,
    total: PropTypes.number,
    creationDate: PropTypes.string,
    createdBy: PropTypes.string,
    lastUpdateDate: PropTypes.string,
    lastUpdatedBy: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
};

ModalPurchaseOrderData.defaultProps = {
  poData: null,
  isLoading: false,
};

export default ModalPurchaseOrderData;
